import React, { useRef, useEffect, useState } from "react";
import { featureData } from "./Data";
import "./CrissCross.css";

function useIntersect(options = {}) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { setVisible(true); obs.disconnect(); }
    }, { threshold: 0.12, ...options });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return [ref, visible];
}

function FeatureRow({ feature, index }) {
  const [ref, visible] = useIntersect();
  const isEven = index % 2 === 0;

  return (
    <div
      ref={ref}
      className={`cc-row ${isEven ? "cc-row--light" : "cc-row--dark"} ${visible ? "cc-row--visible" : ""}`}
    >
      {/* ── index stamp ── */}
      <span className="cc-row__stamp">0{index + 1}</span>

      <div className={`cc-row__inner ${isEven ? "cc-row__inner--imgright" : "cc-row__inner--imgleft"}`}>

        {/* ── TEXT SIDE ── */}
        <div className="cc-text">
          <span className="cc-text__tag">
            {isEven ? "Our Offering" : "Our Network"}
          </span>
          <h2 className="cc-text__title">{feature.title}</h2>
          <div className="cc-text__rule" />

          {feature.description && (
            <p className="cc-text__body">{feature.description}</p>
          )}
          {feature.list && (
            <ul className="cc-text__list">
              {feature.list.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          )}
          {feature.description1 && (
            <p className="cc-text__body">{feature.description1}</p>
          )}
          {feature.list1 && (
            <ul className="cc-text__list cc-text__list--check">
              {feature.list1.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          )}
          {feature.sublist && (
            <ol className="cc-text__sublist">
              {feature.sublist.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ol>
          )}
          {[feature.description2, feature.description3, feature.description4, feature.description5]
            .filter(Boolean)
            .map((d, i) => <p key={i} className="cc-text__body">{d}</p>)
          }
        </div>

        {/* ── IMAGE SIDE ── */}
        {feature.image && (
          <div className="cc-img">
            <div className="cc-img__frame">
              <img
                src={feature.image}
                alt={feature.title}
                className="cc-img__photo"
                loading="lazy"
                decoding="async"
              />
              {/* decorative corner marks */}
              <span className="cc-img__corner cc-img__corner--tl" />
              <span className="cc-img__corner cc-img__corner--br" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default function CrissCross() {
  return (
    <div className="cc-root">
      {featureData.map((feature, index) => (
        <FeatureRow key={index} feature={feature} index={index} />
      ))}
    </div>
  );
}